export enum ENUM__grid2d_cell_size {
  XS = 'XS',
  S = 'S',
  M = 'M',
  L = 'L',
  XL = 'XL',
}

function size_to_columns(size: ENUM__grid2d_cell_size) {
  const out_map = new Map([
    [ENUM__grid2d_cell_size.XL, 2],
    [ENUM__grid2d_cell_size.L, 3],
    [ENUM__grid2d_cell_size.M, 6],
    [ENUM__grid2d_cell_size.S, 9],
    [ENUM__grid2d_cell_size.XS, 12],
  ]);

  return out_map.get_or_assert(size);
}

export namespace ENUM_UTILS__grid2d_cell_size {
  export function size_to_max_side(size: ENUM__grid2d_cell_size): number {
    let out_map = new Map<ENUM__grid2d_cell_size, number>();

    out_map.set(ENUM__grid2d_cell_size.XS, 80);
    out_map.set(ENUM__grid2d_cell_size.S, 120);
    out_map.set(ENUM__grid2d_cell_size.M, 180);
    out_map.set(ENUM__grid2d_cell_size.L, 360);
    out_map.set(ENUM__grid2d_cell_size.XL, 540);

    return out_map.get_or_assert(size);
  }
}
